import {NgModule}            from '@angular/core';
import {Route, RouterModule} from '@angular/router';
import {ApPermissionGuard}   from '../guards/ap-permission-guard.service';
import {PageMode}            from '../ap-interface/enums';
import {PpLogfilesComponent} from './components/pp-logfiles.component';
import {PpOverviewComponent} from './components/pp-overview.component';
import {PpPlanningComponent} from './components/pp-planning.component';
import {PpBookingComponent}  from './components/pp-booking.component';

const routes: Route[] = [
  {
    path: 'logfiles',
    component: PpLogfilesComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    },
  },
  {
    path: 'overview',
    component: PpOverviewComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    },
  },
  {
    path: 'planning',
    component: PpPlanningComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    },
  },
  {
    path: 'booking',
    component: PpBookingComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    },
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class PlantProtectionRoutes {
}
